import { render, staticRenderFns } from "./SetupWifiSuccess.vue?vue&type=template&id=61d8628d&"
import script from "./SetupWifiSuccess.vue?vue&type=script&lang=js&"
export * from "./SetupWifiSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports